import { jsx } from 'react/jsx-runtime';
import { useRef } from 'react';
import { styled } from 'styled-components';
import { useMediaPlayerControls } from '../useMediaPlayerControls.js';
import { useResourceAudioDataContextSafe } from '../../../context/resourceDataContext.js';
import { Flex } from '@fabric-app/ui/components/Flex';
import { Spinner } from '@fabric-app/ui/components/Spinner';
import { useQueryResourceTranscript } from '../../../../queries/useQueryResourceTranscript.js';
import { ResourceMediaPlayer } from '../MediaPlayer/ResourceMediaPlayer.js';
import { useRouteTParamChange } from '../../hooks/useRouteTParamChange.js';

const ResourceAudioPlayer = () => {
  const { resource } = useResourceAudioDataContextSafe();
  const { transcriptLines } = useQueryResourceTranscript(resource);
  const containerRef = useRef(null);
  const { mediaElementProps, mediaElementRef, mediaTimestamp, isReady } = useMediaPlayerControls(resource.id);
  const startPlayAt = async (t) => {
    if (!mediaElementRef.current) return;
    await mediaElementRef.current.play();
    mediaElementRef.current.currentTime = t;
  };
  const onClickTranscript = (cue) => {
    startPlayAt(cue.startTime);
  };
  useRouteTParamChange({
    onParamChange: startPlayAt,
    enabled: isReady
  });
  return /* @__PURE__ */ jsx(ResourceMediaPlayer, {
    transcriptLines: transcriptLines ?? void 0,
    currentTimestamp: mediaTimestamp ?? void 0,
    onTranscriptClick: onClickTranscript,
    containerRef,
    "data-pan-id-ignore-resource-drag-resize": "xy",
    children: !resource.fileUrl ? /* @__PURE__ */ jsx(Flex, {
      justifyContent: "center",
      style: {
        padding: "1rem"
      },
      children: /* @__PURE__ */ jsx(Spinner, {
        opacity: 0.1,
        size: 32
      })
    }) : /* @__PURE__ */ jsx(Audio, {
      ref: mediaElementRef,
      src: resource.fileUrl,
      controls: true,
      ...mediaElementProps,
      draggable: false
    })
  });
};
const Audio = styled.audio.withConfig({
  displayName: "ResourceAudioPlayer__Audio",
  componentId: "sc-599dbb00-0"
})([
  `width:100%;`
]);

export { ResourceAudioPlayer };
//# sourceMappingURL=ResourceAudioPlayer.js.map
